import { checkboxAnatomy } from "@chakra-ui/anatomy";
import { createMultiStyleConfigHelpers } from "@chakra-ui/react";

const { definePartsStyle, defineMultiStyleConfig } = createMultiStyleConfigHelpers(checkboxAnatomy.keys);

const baseStyle = definePartsStyle({
  icon: {
    bg: "text.primary",
    borderColor: "text.primary",
    _checked: {
      bg: "text.primary",
      borderColor: "text.primary",
    },
  },
  control: {
    _checked: {
      bg: "text.primary",
      borderColor: "text.primary",
      _hover: {
        bg: "text.primary",
        borderColor: "text.primary",
      },
    },
  },
});

const checkbox = defineMultiStyleConfig({ baseStyle });

export default checkbox;
